import {CapacitorAudioRecorder} from "@capgo/capacitor-audio-recorder";
import {Capacitor} from "@capacitor/core";

export const startNativeRecording = async () => {
    const perm = await CapacitorAudioRecorder.requestPermissions();

    if (perm.recordAudio !== 'granted') {
        throw new Error("Permessi microfono negati");
    }

    await CapacitorAudioRecorder.startRecording();
};

export const stopNativeRecording = async () => {
    const result = await CapacitorAudioRecorder.stopRecording();
    const uri = result.uri;

    const fileSrc = Capacitor.convertFileSrc(uri);

    // fetch del file locale
    const response = await fetch(fileSrc);
    return await response.blob(); // pronto da inviare al backend
};